/**
 * We manage the platform version manually, following semantic versioning as part of our release process.
 *
 * It is decided to use manual versioning rather than git hash, because:
 * 1. It is much simpler to manage it this way (and can be used directly in codes)
 * 2. Not all changes requires version bumps
 *    e.g: When there is only documentation related changes
 *
 * What about Rollbacks?
 * At the moment versioning strategy decided, Rollbacks are **extremely rare** and is discouraged
 * Given the small team size with no dedicated SRE / Dev Ops we intend to keep it that way
 *
 */

export const platformVersion = '1.29.0';
